import { STORYBLOK_VIDEO_BASE_URL } from "../constants.mjs";

export function getStoryblokVideoUrl(url: string) {
  return url.replace("//a.storyblok.com", STORYBLOK_VIDEO_BASE_URL);
}
